<template>
  <div class="doctype-modal" @keydown.esc="close">
    <u-confirm id="delete-doctype" ref="confirm" />

    <c-sidesheet :active="active" :title="sidesheetHeader" @close="close">
      <template v-if="displayActions" #actions>
        <slot name="sidesheet-actions"></slot>
      </template>
      <div class="doctype-form">
        <div class="doctype-form">
          <slot></slot>
        </div>

        <div class="doctype-form__actions">
          <c-button-2 size="large" class="doctype-form__reset" label="Отменить" @click="reset" />

          <c-button-2
            class="doctype-form__save"
            label="Сохранить"
            color="primary"
            size="large"
            :disabled="pending"
            @click="submit"
          />
        </div>
      </div>
    </c-sidesheet>
  </div>
</template>

<script>
import Sidesheet from "@/components/sidesheet";
import Button2 from "@/components/controls2/Button";
import Confirm from "@/pages/documents/u-confirm";

export default {
  name: "reference-sidesheet",
  components: {
    "c-sidesheet": Sidesheet,
    "c-button-2": Button2,
    "u-confirm": Confirm,
  },
  props: {
    sidesheetHeader: {
      type: String,
      default: () => "Заголовок сайдшита",
    },
    displayActions: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      active: false,
      pending: false,
    };
  },

  created() {
    document.getElementsByTagName("body")[0].addEventListener("click", () => {
      this.$root.$emit("bv::hide::popover");
    });

    document.addEventListener("keyup", (evt) => {
      if (evt.keyCode === 27) {
        if (this.active) {
          this.close();
        }
      }
    });
  },
  methods: {
    open() {
      this.active = true;
    },
    close() {
      this.active = false;
      this.$emit("close");
    },
    submit() {
      this.$emit("onSubmit");
    },
    reset() {
      this.$emit("onReset");
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

::v-deep .sidesheet__wrapper {
  width: calc(100vw - 161px);
  padding: 38px 31px 38px 31px;

  @media screen and (max-width: 1024px) {
    width: calc(100vw - 62px);
  }

  @media screen and (max-width: 700px) {
    padding: 28px 20px;
    max-width: 100%;
    width: 100%;
  }
}

.doctype-form {
  max-width: 762px;

  &__name {
    margin-bottom: 22px;
  }

  &__name,
  &__description {
    max-width: 565px;
  }

  &-issues {
    margin-top: 40px;

    h2 {
      font-size: 18px;
      font-weight: 500;
      margin-bottom: 20px;
    }

    &__colors {
      display: flex;
    }

    &__color {
      margin-right: 35px;
    }
  }

  &__actions {
    margin-top: 40px;
    display: flex;
    align-items: center;
  }

  &__reset {
    margin-right: 10px;
    width: 120px;
    padding: 0;
    background: #fff;
  }

  &__save {
    width: 125px;
    padding: 0;
  }

  &__name {
    margin-bottom: 40px;
  }

  @media (min-width: 680px) {
    margin-top: 24px;
  }

  @media screen and (max-width: 1024px) {
    &__name,
    &__description {
      width: 100%;
      max-width: 680px;
    }
  }
}

@media (max-width: 480px) {
  .doctype-modal {
    position: relative;
  }
  .doctype-form__actions {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }
  .doctype-form__actions button {
    width: 50%;
    margin: 0;
    border-radius: 0;
  }
}
::v-deep .sidesheet__header {
  margin-top: -10px;
}
</style>
